import {
	preAppConstants
} from './preApp.constants';

export const preAppActions = {
	resetApplicationState
};

function resetApplicationState() {
	return { type: preAppConstants.RESET_APPLICATION_STATE };
}